"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AccordionTitle_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Accordion/AccordionTitle"));
var AccordionContent_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Accordion/AccordionContent"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
/**
 * Each Content component acts as an individual collapsible section within the parent Accordion.
 * A Content section is opened and closed by clicking on a title that must be provided.
 * This Content component can contain other web components within.
 */
var AccordionContent = /** @class */ (function (_super) {
    __extends(AccordionContent, _super);
    function AccordionContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionContent.prototype.render = function () {
        var _a = this.props, active = _a.active, onClick = _a.onClick, disabled = _a.disabled, title = _a.title, children = _a.children, arrowPosition = _a.arrowPosition, rest = __rest(_a, ["active", "onClick", "disabled", "title", "children", "arrowPosition"]);
        return (React.createElement("div", __assign({}, rest),
            React.createElement(AccordionTitle_1.default, { active: active, onClick: onClick, className: disabled ? 'disabled' : '' },
                title,
                React.createElement(Icon_1.default, { className: this.genIconClasses(), root: "common", name: active ? 'caret-up' : 'caret-down', size: "small" })),
            React.createElement(AccordionContent_1.default, { active: active }, children)));
    };
    AccordionContent.prototype.genIconClasses = function () {
        var classes = 'root-icon';
        var arrowPosition = this.props.arrowPosition;
        if (arrowPosition === 'left') {
            classes += ' left';
        }
        return classes;
    };
    AccordionContent.defaultProps = {
        /** Is content disabled? Default is false */
        disabled: false,
        arrowPosition: 'right',
    };
    return AccordionContent;
}(React.Component));
exports.default = AccordionContent;
